import React, { useState } from "react";
import { motion } from "framer-motion";
import { Play, Images } from "lucide-react";
import { Lightbox } from "./Lightbox";
import { useTranslate } from "../context/TranslateContext";
import { galleryForMovie, BACKDROPS } from "../mock/data";

export const TrailerGallery = ({ movie, accent }) => {
  const { t } = useTranslate();
  const images = galleryForMovie(movie.id);
  const [lb, setLb] = useState({ open: false, index: 0, auto: false });

  const openTrailer = () => setLb({ open: true, index: 0, auto: true });
  const openGallery = (idx) => setLb({ open: true, index: idx, auto: false });

  return (
    <div>
      <div className="mb-6 flex items-center gap-3">
        <Play className="h-5 w-5" style={{ color: accent }} />
        <h2 className="font-display text-3xl font-semibold text-cream md:text-4xl">{t("Trailer & Gallery")}</h2>
        <div className="h-px flex-1" style={{ background: accent + "4d" }} />
      </div>

      {/* Trailer player */}
      <button onClick={openTrailer} data-testid="trailer-play"
        className="group relative block w-full overflow-hidden rounded-2xl border border-edge">
        <div className="aspect-video overflow-hidden">
          <img src={BACKDROPS[movie.id]} alt={`${movie.title} trailer`} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
        </div>
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="flex h-20 w-20 items-center justify-center rounded-full backdrop-blur-md transition-transform duration-300 group-hover:scale-110"
            style={{ background: accent + "e6" }}>
            <Play className="ml-1 h-8 w-8 fill-ink text-ink" />
          </span>
        </span>
        <span className="absolute bottom-5 left-6 font-body text-sm uppercase tracking-[0.25em] text-paper drop-shadow-lg">{t("Watch the teaser")}</span>
      </button>

      {/* Gallery strip */}
      <div className="mt-5 flex items-center gap-2 font-body text-sm text-ash"><Images className="h-4 w-4" style={{ color: accent }} /> {t("Gallery")}</div>
      <div className="mt-3 grid grid-cols-2 gap-4 sm:grid-cols-4" data-testid="gallery-strip">
        {images.map((src, idx) => (
          <motion.button key={idx} whileHover={{ y: -4 }} onClick={() => openGallery(idx)} data-testid={`gallery-thumb-${idx}`}
            className="group overflow-hidden rounded-xl border border-edge">
            <div className="aspect-[4/3] overflow-hidden">
              <img src={src} alt="" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
            </div>
          </motion.button>
        ))}
      </div>

      <Lightbox images={images} open={lb.open} startIndex={lb.index} auto={lb.auto} title={movie.title}
        onClose={() => setLb((s) => ({ ...s, open: false }))} />
    </div>
  );
};
